// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2WB-x","imageUploader":"EGiftCard_imageUploader__1kAXD"};